import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { setSessionStorageItem } from '../../utils/storageHelpers';
import { getTabStore } from '../../utils/store/getStore';

// HACK: only usable for one-level-nested-object-typed form values right now, should be extended later

/**
 * This component controls form persistence by storing form values in
 * session storage. It works with react-hook-form context and should be placed under FormProvider as the first child-component
 */
interface Props {
    formName: string;
}

const notSaveableFormNameMap = {
    organization: true,
    requester: true
};

export default function FormPersistController({ formName }: Props) {
    const { getValues } = useFormContext();
    useEffect(() => {
        return () => {
            // TICKET-{id}, USER-{id}, ORGANIZATION-{id}
            const possibleTabKey = formName.split('/').pop();

            if (notSaveableFormNameMap?.[possibleTabKey]) return;

            const saveableFormName = getTabStore().tabs.find(
                ({ key }) => key === possibleTabKey || key === `newTicket${possibleTabKey}`
            );

            if (saveableFormName) setSessionStorageItem(formName, getValues());
        };
    }, [formName, getValues]);

    return null;
}
